import styled from '@emotion/styled';

export const StyledContentWrapper = styled.div`
  padding: 1rem;
`;
export const StyledContent = styled.div``;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  align-items: center;
`;

export const InfoItemTitle = styled.div`
  padding: 3px 0;
  font-weight: 600;
`;

export const InfoItem = styled.div`
  color: ${({ theme }) => theme.palette?.text?.secondary};
`;

export const StyledOption = styled.div<{ isSelected?: boolean }>`
  border-radius: 15px;
  border: 1px solid  ${({ theme, isSelected }) =>
    isSelected ? theme.palette?.brand.primary.base : '#E6E5EA'};
  padding: 1rem;
  background: ${({ isSelected }) => (isSelected ? '#F5F5F5' : 'none')};
  margin-bottom: 1rem;
`;

export const StyledCheckboxOption = styled.div`
  display: flex;
  align-items: center;

  .MuiButtonBase-root{
    input {
      padding: 1.5rem;
      border-radius: 100% !important;
      background-color: ${({ theme }) => theme.palette?.brand.primary.base};
    }
  }
`;

export const StyledCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledOptionHeader = styled.span`
  font-family: 'Urbanist';
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
`;

export const StyledAvatar = styled.div<{
  color: string;
}>`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 100%;
  background-color: ${({ color }) => color};
  margin-right: 10px;
`;

export const StyledInfoChip = styled.div`
display: flex;
align-items: center;
`;

export const StyledWarningMessage = styled.div`
  background-color: ${({ theme }) => theme.palette?.brand.attention[100]};
  color: ${({ theme }) => theme.palette?.brand.attention[700]};
  border-radius: 10px;
  padding: 1rem;
  display: flex;
  align-items: center;
`;
